import { Avatar } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { getNickName } from '../../utils/commonUtils';
import { TimeFormatter } from '../../utils/timeParser';
import Wrapper from './style';
import {
  notificationWording,
  notificationRedirect,
} from '../../utils/notification';

const statusType = {
  READ: 2,
  UNREAD: 1,
};

const Index = (props) => {
  const { dataSource, smallPadding = false } = props;
  const history = useHistory();
  const {
    // subtitle,
    created_at: createdAt,
    read_status: status,
    // body,
  } = dataSource;
  const dataBody = {};
  const title = notificationWording(dataSource);
  const users = dataBody?.user;
  const username = users?.name;
  const urlLink = users?.documents?.url_link;
  const isReadStatus = status === statusType.READ;

  return (
    <Wrapper
      smallPadding={smallPadding}
      isReadStatus={isReadStatus}
      className="container_notification_wrapper"
      onClick={() => {
        notificationRedirect(dataSource, history);
      }}
    >
      <div className="container_notification">
        <div className="component_account_card_photo">
          {urlLink && <Avatar src={urlLink} />}
          {!urlLink && (
            <Avatar className="component_account_card_text">
              {username?.length > 0 && getNickName(username)}
            </Avatar>
          )}
        </div>
        <div className="component_notification_text">
          <div className="font-paragraph component_notification_title">
            {/* <span className="component_notification_title_bold">{name}</span>
            &nbsp;in&nbsp;
            <span className="component_notification_title_bold">Team</span>
            {` ${title} "${subtitle}"`} */}
            {title}
          </div>
          <div className="font-caption_medium component_notification_timer">
            {TimeFormatter(createdAt).additional}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Index;
